import { getErrorMessage, handleApiError } from "../utils/axios-error";
import axiosClient from "../utils/fetchAxiosClient";

export interface SSORequest {
  sso: {
    provider: "okta" | "azure" | "ping" | "idaptive";
    certificate?: string;
  };
  uuid: string; // Required: UUID to look up onboarding record and determine target environment
}

export const ssoService = {
  async updateSso(clientId: string, data: SSORequest) {
    try {
      const response = await axiosClient.put(
        `/tenant-provision/${clientId}/sso`,
        data
      );
      return response.data;
    } catch (error: unknown) {
      console.error("Error updating SSO:", getErrorMessage(error));
      throw handleApiError(error);
    }
  }
};
